<template>
  <!-- 添加一个组页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">区域列表</span>
        <input slot="config_title_hang_ele7"
               type="text"
               placeholder="快速搜索"
               v-model="scerchValue" />
        <span slot="config_title_hang_ele6"
              @click="allRegionOperate(0)">取消所有</span>
        <span slot="config_title_hang_ele5"
              @click="allRegionOperate(1)">选择所有</span>
      </config-title-hang>

      <config-hang v-for="(value, index) in OneGroupRuleObjectRegionList.groupRegionList"
                   :key="index"
                   :selectState="value.checked"
                   @click.native="configHangSelectGroupRegionBtnHandle(value)">
        <span slot="config_hang_ele2">{{value.regionName}}</span>
        <img slot="config_hang_weixuan"
             src="~assets/img/config/weixuan.png"
             alt />
        <img slot="config_hang_xuanzhong"
             src="~assets/img/config/xuanzhong.png"
             alt />
      </config-hang>

      <div class="public_config_que_ren_btn"
           @click="configQueRenBtn">保存并返回</div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data () {
    return {
      OneGroupRuleObjectRegionList: {
        //页面加载指向服务器获取的仓库地址数据
        ruleList: [],
        groupDeviceList: [],
        groupRegionList: [],
      },
      OneGroupRuleObjectRegionListBack: {
        //页面加载指向服务器获取的仓库地址数据 用来搜索备份
        ruleList: [],
        groupDeviceList: [],
        groupRegionList: [],
      },
      scerchValue: "", // 搜索使用
      checkDeviceList: [], /////选中设备的list，需要存到仓库实时更新
    };
  },
  computed: {},
  components: {
    configHang,
    configTitleHang,
  },
  methods: {
    configQueRenBtn () {
      ///处理一下入参   得到选中的区域list
      let checkGroupRegionList = [];
      // this.checkDeviceList.length =
      // console.log(this.OneGroupRuleObjectRegionList.groupDeviceList.length)
      let length = this.OneGroupRuleObjectRegionList.groupRegionList.length;
      let checkLength = 0;
      // console.log(length)
      for (let i = 0; i < length; i++) {
        if (
          this.OneGroupRuleObjectRegionList.groupRegionList[i].checked === true
        ) {
          checkGroupRegionList[
            checkLength
          ] = this.OneGroupRuleObjectRegionList.groupRegionList[i].regionId;
          checkLength++;
        }
      }

      // 代号20200731-4
      if (checkLength <= 0) {
        this.$toast("请至少选择一个区域~");
        return;
      }
      // console.log(this.OneGroupRuleObjectRegionList.ruleList);
      // console.log(this.checkDeviceList);

      /// 请求区域信息接口，获取数据
      this.$request({
        method: "post",
        url: "/userGroup/findGroupDeviceList",
        data: {
          token: this.$store.state.token,
          deviceId: this.OneGroupinfo.deviceId,
          // ruleList: this.ServeGroupRule, ///传入当前页面的规则列表
          checkDeviceList: this.checkDeviceList, ///
          regionIds: checkGroupRegionList, ///传入要筛选的区域列表，空的话代表所有区域
        },
      })
        .then((res) => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeGroupRule = res.data.data; ////拿到服务器返回的数据结果
            this.$store.dispatch(
              "asyUpdataOneGroupRuleObjectRegionList",
              res.data.data
            ); ////把服务器获取到的规则列表地址存到仓库
            console.log(res.data.data);
            this.$router.go(-1); ////返回上个页面
            //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
            // this.$router.push('ConfigAddGroupRule')
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    configHangSelectGroupRegionBtnHandle (value) {
      value.checked = !value.checked;
      console.log(this.OneGroupRuleObjectRegionList.groupRegionList);
    },
    allRegionOperate (data) {
      //  代号20200731-4
      let regionLength = this.OneGroupRuleObjectRegionList.groupRegionList
        .length;
      if (data == 0) {
        //s说明是取消所有的选择区域
        for (let i = 0; i < regionLength; i++) {
          this.OneGroupRuleObjectRegionList.groupRegionList[i].checked = false;
        }
      } else if (data == 1) {
        //说明是选择所有的区域
        for (let i = 0; i < regionLength; i++) {
          this.OneGroupRuleObjectRegionList.groupRegionList[i].checked = true;
        }
      }
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow (charData) {
      if (
        this.OneGroupRuleObjectRegionList.groupRegionList &&
        this.OneGroupRuleObjectRegionListBack.groupRegionList
      ) {
        //数据是合法存在的
        this.OneGroupRuleObjectRegionList.groupRegionList = this.OneGroupRuleObjectRegionList.groupRegionList.concat(
          this.OneGroupRuleObjectRegionListBack.groupRegionList
        );
        this.OneGroupRuleObjectRegionListBack.groupRegionList.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.OneGroupRuleObjectRegionList.groupRegionList.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              this.OneGroupRuleObjectRegionList.groupRegionList[i].regionName.indexOf(charData) == -1
            ) {
              // && this.OneGroupRuleObjectRegionList.groupRegionList[i].checked == false
              // 说明没有这个字符
              this.OneGroupRuleObjectRegionListBack.groupRegionList.push(
                this.OneGroupRuleObjectRegionList.groupRegionList[i]
              );
              this.OneGroupRuleObjectRegionList.groupRegionList.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.OneGroupRuleObjectRegionList.groupRegionList);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  mounted () {
    console.log("mounted阶段");
  },
  created () {
    console.log("created阶段");

    //// 把仓库的一个组信息的地址拿过来  拿的是地址  并不是数据
    this.OneGroupinfo = this.$store.state.configinfo.OneGroupinfo;
    ///把仓库的一个组的规则区域对象拿过来
    this.OneGroupRuleObjectRegionList = this.$store.state.configinfo.OneGroupRuleObjectRegionList;
    ///把仓库存储的 一条组信息的勾选对象地址拿过来
    // console.log(this.$store.state.configinfo.OneGroupRuleList);
    this.checkDeviceList = this.$store.state.configinfo.checkDeviceList;

    // this.checkDeviceList = this.$store.state.configinfo.checkDeviceList
    console.log(this.checkDeviceList);
  },
  destroyed () {
    //页面销毁之前
    console.log("页面即将销毁")
    // 销毁页面之前 恢复数据  数据搜索
    this.scerchValue = "";
    if (this.OneGroupRuleObjectRegionListBack.groupRegionList.length != 0) {
      //所有搜索备份的数据还没有完全恢复
      this.OneGroupRuleObjectRegionList.groupRegionList = this.OneGroupRuleObjectRegionList.groupRegionList.concat(this.OneGroupRuleObjectRegionListBack.groupRegionList);
      this.OneGroupRuleObjectRegionListBack.groupRegionList.length = 0;
    }
  }
};
</script>

<style>
.config_select_group_object_title_height {
  height: 15px;
}
/* .config_select_group_object_hang_height{
  height: 80px;
} */
</style>